module.exports = __webpack_public_path__ + "static/media/play-boss-egg-broken.49c8ba32.png";